import { z } from 'zod';
import { BaseSchema } from './baseSchema';

export const ThesaurusTermSchema = BaseSchema.extend({
    term: z.string(),
    term_id: z.string(),
    web_path: z.string().nullable(),
    uri: z.string().nullable(),
});

export const InformeSchema = BaseSchema.extend({
    term: z.string(),
    pdf_resolved: z.string().nullable(),
});

export const ThesaurusTreeSchema = BaseSchema.extend({
    term: z.string(),
    term_id: z.string(),
    web_path: z.string().nullable(),
    parent: z.string(),
    uri: z.string().nullable(),
    pdf_resolved: z.string().nullable(),
});

export const ThesaurusCheckTermSchema = BaseSchema.extend({
    term_id: z.string(),
    parents: z.string(),
});

export const ThesaurusBlockSchema = BaseSchema.extend({
    term: z.string(),
    abstract: z.string(),
    body: z.string(),
    image: z.array(
        z.object({
            image: z.string(),
            footprint: z.string().nullable(),
        })
    ),
});

export const ThesaurusChildrenSchema = BaseSchema.extend({
    term: z.string(),
    term_id: z.string(),
    web_path: z.string().nullable(),
});

export const ThesaurusAreaSchema = BaseSchema.extend({
    term: z.string(),
    abstract: z.string().nullable(),
    body: z.string(),
    image: z.array(
        z.object({
            image: z.string(),
            footprint: z.string().nullable(),
        })
    ),
    indexations: z.string().nullable(),
    uri: z.string().nullable(),
    bibliography_data: z.array(
        z.object({
            ref_publications_title: z.string(),
            ref_publications_authors: z.string().nullable(),

        })
    ),
    documents_indexation: z.string().nullable(),
});